export {
    connectWithPage, PageContainer, usePage,
} from "./page.container";
export type { IPageContainerProps } from "./page.container";
export type { IPageContainerState } from './page';
